<template>
	<div class="cloud-container">
		<img src="@/assets/images/logo.png" alt="logo" class="logo" />

		<div class="login-containers" v-show="loginLabeShow === true">
			<img src="@/assets/images/loginbg.png" style="width: 100%; height: 100%; z-index: 1;" />
			<div class="login-title">
				<p>欢迎登录咏思信息隧道化平台</p>
			</div>
			<div class="login-box">
				<el-form ref="loginForm" :model="loginForm" label-position="top" :rules="Loginrules"
					label-width="130px">
					<el-form-item label="用户名称：" prop="username">
						<el-input v-model="loginForm.username" placeholder="请输入用户名称"></el-input>
					</el-form-item>
					<el-form-item label="用户密码：" prop="password">
						<el-input v-model="loginForm.password" placeholder="请输入用户密码" show-password></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-checkbox v-model="checked" style="float: left; color: #fff;">记住账号</el-checkbox>
					</el-form-item>
					<el-form-item label="">
						<el-button type="success" @click="handleLoginClick">登录</el-button>
						<el-button type="primary" @click=" loginLabeShow = false">申请注册</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div class="login-containerssq" v-show="loginLabeShow === false">
			<img src="@/assets/images/loginSq.png" style="width: 100%; height: 100%; z-index: 1;" />
			<div class="login-title">
				<p>欢迎登录咏思信息隧道化平台</p>
			</div>
			<div class="login-box">
				<el-form ref="formUserRegister" :model="formUserRegister" label-position="top" :rules="rules"
					label-width="130px">
					<el-form-item label="联系人：" prop="name">
						<el-input v-model="formUserRegister.name" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<el-form-item label="联系电话：" prop="telephone">
						<el-input v-model="formUserRegister.telephone" placeholder="请输入联系电话"></el-input>
					</el-form-item>
					<el-form-item label="公司全称：" prop="companyName">
						<el-input v-model="formUserRegister.companyName" placeholder="请输入公司全称"></el-input>
					</el-form-item>
					<el-form-item label="想了解的产品：">
					</el-form-item>
					<el-form-item label="" prop="typeName">
						<el-checkbox-group v-model="checkedCities">
							<el-checkbox style="margin-left: 0px; float: left;" v-for="city in cities" :label="city"
								:key="city">{{
									city
								}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-button type="success" @click="handleMDLoginClick">提交申请</el-button>
					<el-button type="primary" @click=" loginLabeShow = true">账号登录</el-button>
				</el-form>
			</div>
		</div>

		<div class="login-footer">@2025 广东咏思隧道 版权所有</div>

		<el-dialog title="演示平台进入申请" :visible.sync="dialogVisible" width="900px" height="500px"
			:before-close="handleClose">
			<div style="width: 90%; margin: 0 auto; height: 500px; position: relative;"
				class="custom-gradient-bg-dialog">
				<div class="page-container">
					<img src="@/assets/images/640.gif" alt="register" style="width: 100%; height: 100%;" />
					<div
						style="position: absolute; top: 80%; left: 50%; transform: translate(-50%, -50%); color: #666; width: 100%; ">
						<p style=" width: 100%; margin: 0px; padding: 0px; height: 28px;">
							审核预计需要几分钟，请耐心等待，审核结束后，会自动跳转到下一个页面</p>
						<p style=" width: 100%; margin: 0px; padding: 0px; height: 28px;">如有疑问，请联系管理员<span
								style="color: red;">（点击姓名自动弹窗微信二维码）</span></p>
						<p style=" width: 100%; margin: 0px; padding: 0px; height: 28px;">
							<span style="padding-right: 50px;"
								@click="handleClick('黄先生：13790021371')">黄先生：13790021371</span>
							<span style="padding-left: 50px;" @click="handleClick('利先生：18664206234')">利先生：
								18664206234</span>
						</p>
					</div>
					<div class="contacts-container" v-show="showQrcode">
						<div class="contact-item" style="margin-right: 10%;">
							<div class="qrcode"><img src="@/assets/images/huanzong.jpg"></div>
							<div class="contact-info">
								<div class="contact-name">黄先生</div>
								<div class="contact-phone">13790021371</div>
							</div>
						</div>

						<div class="contact-item">
							<div class="qrcode"><img src="@/assets/images/lixuan.jpg"></div>
							<div class="contact-info">
								<div class="contact-name">利先生</div>
								<div class="contact-phone">18664206234</div>
							</div>
						</div>

						<div class="close-btn" @click="showQrcode = false">关闭</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { login, userRegisterAdd, userRegisterList } from '@/public/api.js'
import { encryptJson, decryptJson } from '@/utils/crypto';
import CryptoJS from 'crypto-js';
import { setLocalStorageWithExpiry } from '@/utils/index.js';

// 引入路由实例
export default {
	name: 'loginpage',
	components: {
	},
	data() {
		return {
			// 登录表单数据
			loginForm: {
				username: '',
				password: '',
				type: "item"
			},

			loginShow: true,
			checked: false,
			submitShow: true,
			showQrcode: false,
			loginLabeShow: window.location.hostname !== 'sd.yongsixinxi.com',
			formUserRegister: {
				name: '',
				telephone: '',
				companyName: '',
				typeName: [],
				status: '0',
			},
			dialogVisible: false,
			token: null, // 登录token
			rules: {
				name: [
					{ required: true, message: '请输入联系人', trigger: 'blur' },
					{ min: 2, max: 10, message: '姓名长度必须在2-10个字符之间', trigger: 'blur' }
				],
				telephone: [
					{ required: true, message: '请输入联系电话', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
				],
				companyName: [
					{ required: true, message: '请输入公司名称', trigger: 'blur' },
					{ min: 6, max: 30, message: '姓名长度必须在6-30个字符之间', trigger: 'blur' }
				],
				typeName: [
					{ required: true, message: '请输入想了解的产品', trigger: 'blur' },
				],
			},
			Loginrules: {
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' },
					{ min: 2, max: 13, message: '用户名长度必须在2-12个字符之间', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, max: 32, message: '密码长度必须在6-32个字符之间', trigger: 'blur' }
				],
			},
			checkedCities: ['人员定位', '气体检测'],
			cities: ['人员定位', '气体检测', '人车门禁', '安全步距', '项目管理', '党建平台'],
			totalSeconds: 3 * 60, // 3分钟倒计时
			progress: 15, // 初始进度
			countdownInterval: null
		}
	},
	computed: {
		// 格式化时间显示 (mm:ss)
		formattedTime() {
			const minutes = Math.floor(this.totalSeconds / 60);
			const seconds = this.totalSeconds % 60;
			return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
		}
	},
	mounted() {
		let that = this;
		if (localStorage.getItem('updateTokenPass') === null || localStorage.getItem('updateTokenPass') === '' || localStorage.getItem('updateTokenPass') === undefined) {
			localStorage.getItem('updateTokenPass', null);
		} else {
			let userName = this.loginForm.username;
			const decryptedData = decryptJson(localStorage.getItem('updateTokenPass'));

			login(decryptedData).then(res => {
				if (res.data.code !== 200) {
					return this.$message.error(res.data.message);
				} else {
					setLocalStorageWithExpiry('updateToken', res.data.data.token, 24 * 60);
					setLocalStorageWithExpiry('updateUserName', userName, 24 * 60);
					localStorage.setItem('transferDepartmentListData', JSON.stringify(res.data.data.departmentList)); // 序列化存储
					this.$router.push('/home');
				}

			})
		}

	},
	methods: {
		handleLoginClick() {
			let that = this;
			let userName = this.loginForm.username;
			this.loginForm.password = this.encryptData(this.loginForm.password);
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					login(this.loginForm).then(res => {
						if (res.data.code !== 200) {
							return this.$message.error('登录失败,密码出错或者用户不存在！');
						} else {
							localStorage.setItem('updateTokenPass', encryptJson(this.loginForm));
							setLocalStorageWithExpiry('updateToken', res.data.data.token, 24 * 60);
							setLocalStorageWithExpiry('updateUserName', userName, 24 * 60);
							localStorage.setItem('transferDepartmentListData', JSON.stringify(res.data.data.departmentList)); // 序列化存储
							this.$router.push('/home');
						}
					})
				}
			})
		},
		// AES加密方法
		encryptData(data) {
			const key = CryptoJS.enc.Utf8.parse('1234567890abcdef'); // 16位密钥(AES-128)
			const iv = CryptoJS.enc.Utf8.parse('abcdef1234567890');  // 16位IV
			const encrypted = CryptoJS.AES.encrypt(
				CryptoJS.enc.Utf8.parse(data),
				key,
				{
					iv: iv,
					mode: CryptoJS.mode.CBC,
					padding: CryptoJS.pad.Pkcs7
				}
			);
			return encrypted.toString(); // 返回Base64格式密文
		},
		handleClick(name) {
			this.showQrcode = true;
		},
		handleMDLoginClick() {
			this.handleRegisterClick();
		},
		handleClose() {
			this.dialogVisible = false;
		},
		handleRegisterClick() {
			let that = this;

			that.checkedCities.forEach(item => {
				that.formUserRegister.typeName += item + ',';
			});

			this.$refs.formUserRegister.validate((valid) => {
				if (valid) {
					that.dialogVisible = true;
					that.formUserRegister.typeName = that.formUserRegister.typeName.substring(0, that.formUserRegister.typeName.length - 1);

					userRegisterAdd(that.formUserRegister).then(res => {
						if (res.data.data.code === 300) {
							return that.$message.error("当前用户已存在，需要再次试用，请联系管理人员！");
						} else if (res.data.data.code !== 200) {
							return that.$message.error("当前用户异常，需要试用，请联系管理人员！");
						} else {
							this.submitShow = false;
							this.countdownInterval = setInterval(this.updateCountdown, 1000);
							let timer = setInterval(() => {
								that.formUserRegister.status = '1';
								userRegisterList(that.formUserRegister).then(resUser => {
									if (resUser.data.code === 200) {
										resUser.data.rows.forEach(item => {
											if (item.status === '1') {
												that.loginForm = {
													username: item.telephone,
													password: item.password,
													type: "item"
												}


												const h = this.$createElement;
												this.$msgbox({
													title: '温馨提示',
													message: h('div', null, [
														h('p', null, `当前用户账号为：${item.telephone}`),
														h('p', null, `登录密码为：${item.password}`),
														h('p', null, '请确认登录，同时保存登录账号密码，便于后续使用！')
													]),
													confirmButtonText: '确定',
													callback: action => {
														that.handleLoginClick();
													}
												});

												clearInterval(timer);

											}
										})
									}

								})
							}, 3500);
						}
					})
				} else {
					this.$message.error('请填写完整信息');
				}
			});
		},
		// 更新倒计时
		updateCountdown() {
			if (this.totalSeconds <= 0) {
				clearInterval(this.countdownInterval);
				// 审核完成，这里可以添加跳转逻辑
				// 例如: this.$router.push('/next-page')
				alert('审核失败，请重新申请，或者联系管理员！');
				return;
			}

			// 计算进度更新
			const progressIncrement = (85 / (this.totalSeconds + 1)); // 剩余进度的比例
			this.progress += progressIncrement;
			if (this.progress > 100) this.progress = 100;

			this.totalSeconds--;
		},
		handUserTypeClick() {
			if (this.loginLabeShow === false) {
				this.loginLabeShow = true;
			} else {
				this.loginLabeShow = false;
			}
		},
	},
	beforeDestroy() {
		// 组件销毁前清除定时器
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}
}
</script>
<style scoped>
.cloud-container {
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	::v-deep .el-dialog {
		height: 600px !important;
	}

	>.logo {
		position: absolute;
		top: 5%;
		left: 5%;
		width: 10rem;
		height: auto;
	}

	>.login-containers {
		position: relative;
		margin-top: 10%;
		margin-left: 73%;
		width: 28.8rem;
		height: 29.8rem;
		border-radius: 16px 16px 16px 16px;

		>.login-title {
			position: absolute;
			top: 3%;
			left: 18%;
			width: 80%;
			height: auto;

			>p {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 1.4rem;
				color: #FFFFFF;
				line-height: 2.5rem;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin: 0px;
				padding: 0px;
			}
		}

		>.login-box {
			position: absolute;
			top: 25%;
			left: 10%;
			width: 80%;
			height: auto;
		}
	}

	>.login-containerssq {
		position: relative;
		margin-top: 7%;
		margin-left: 73%;
		width: 28.8rem;
		height: 36.8rem;
		border-radius: 16px 16px 16px 16px;

		>.login-title {
			position: absolute;
			top: 3%;
			left: 18%;
			width: 80%;
			height: auto;

			>p {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 1.4rem;
				color: #FFFFFF;
				line-height: 2.5rem;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin: 0px;
				padding: 0px;
			}
		}

		>.login-box {
			position: absolute;
			top: 15%;
			left: 10%;
			width: 80%;
			height: auto;
		}
	}

	>::v-deep .el-form-item__label {
		font-size: 0.8rem;
		color: #FFFFFF !important;
		line-height: 1.5rem;
		text-align: left;
		float: left;
		font-style: normal;
		text-transform: none;
		margin: 0px;
		padding: 0px;
	}

	>::v-deep .el-checkbox {
		color: #FFFFFF !important;
	}

	.custom-gradient-bg-dialog {

		/* 页面容器 - 替代所有背景和布局类 */
		.page-container {
			/* 背景渐变 */
			/* background: linear-gradient(135deg, #eff6ff 0%, #e0e7ff 100%); */
			/* 全屏高度 */
			min-height: 300px;
			/* 布局 */
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			/* 内边距 */
			padding: 0px 6px;
			margin-top: -30px;
			/* 字体 */
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
		}


		.contacts-container {
			width: 85%;
			height: auto;
			margin: 0 auto;
			margin-top: 53%;
			position: absolute;
			background-color: #fff;
			z-index: 1000;
			padding-left: 30%;

			>.contact-item {
				width: 200px;
				height: auto;
				margin: 0 auto;
				float: left;

				>.qrcode {
					width: 80%;
					height: auto;

					>img {
						width: 200px;
						height: 200px;
					}
				}

				>.contact-info {
					color: #333;
					font-size: 1.4rem;
					font-weight: bold;
				}

			}

			>.close-btn {
				width: 50px;
				color: #333;
				font-size: 0.8rem;
				font-weight: bold;
				cursor: pointer;
				background-color: #e0e0e0;
				padding: 5px 10px;
				border-radius: 50px;
				float: right;
				margin-right: 10%;
			}
		}
	}

	>.login-footer {
		position: absolute;
		bottom: 5%;
		left: 10%;
		width: 80%;
		height: auto;
	}
}
</style>